export const REGISTERREQUEST = "REGISTERREQUEST"
export const REGISTERFAILURE = "REGISTERFAILURE"
export const REGISTERSUCCESS = "REGISTERSUCCESS"
